import {SearchClearIconDefaultBox} from "./search-clear-icon.default.box";
import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {SearchClearIconCasino777Box} from "./search-clear-icon.casino777.box";

export interface ISearchClearIconBoxProps {
    visible: boolean;
}

export const SearchClearIconBox = styledByTheme(SearchClearIconDefaultBox)
    .forCasino777(SearchClearIconCasino777Box)
    .apply();